import type { GamingScorePersistedData } from '@playcastdotio/Messaging';

export type GamingScoreRequest = (url: string) => Promise<Pick<Response, 'status' | 'ok' | 'json'>>;

/** Reads the existing persisted gaming score from the configured realtime API. */
export class GamingScoreApiService {
  public constructor(private readonly baseUrl: string, private readonly request: GamingScoreRequest) {}

  public async read(machineId: string): Promise<GamingScorePersistedData | null> {
    const request = this.request;
    const response = await request(`${this.baseUrl}realtime/machines/${encodeURIComponent(machineId)}/gaming-score`);
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`Failed to fetch gaming score (${response.status})`);
    return await response.json() as GamingScorePersistedData;
  }
}
